import { CustomizableLayout } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";
import { MissingUserData } from "~/utils/user-helpers";

const missingDataMessages: Record<MissingUserData, string> = {
    [MissingUserData.PROFILE_NAME]: "set your name",
    [MissingUserData.PROFILE_IMAGE]: "upload your profile picture",
    [MissingUserData.PROFILE_EMAIL]: "set your contact email",
    [MissingUserData.PROFILE_BIO]:
        "provide couple sentences about yourself in bio",
    [MissingUserData.PROFILE_SOCIAL]: "set at least one social media link",
    [MissingUserData.CONTACT_WHATSAPP]: "provide a WhatsApp contact",
    [MissingUserData.CONTACT_TELEGRAM]: "provide a Telegram contact",
    [MissingUserData.CONTACT_ANY_CHAT]:
        "provide either Telegram or WhatsApp contact",
    [MissingUserData.CONTACT_LINKEDIN]: "provide a LinkedIn contact",
    [MissingUserData.PROFILE_PHONE_NUMBER]:
        "Please provide your phone number in case the community manager needs to reach you.",
};

const MissingProfileFieldsList: React.FC<{
    missingData: MissingUserData[];
    customization?: CustomizableLayout;
}> = ({ missingData, customization }) => (
    <ul className={cn("text-base", customization?.descriptionClassName)}>
        {missingData.map((data) => (
            <li key={data}>• {missingDataMessages[data]}</li>
        ))}
    </ul>
);

export default MissingProfileFieldsList;
